/**
 * 文本格式化工具
 */

import { EMPTY_PLACEHOLDER } from './constants';

/**
 * 格式化手机号 (脱敏)
 *
 * @param phone - 手机号
 * @param mask - 掩码字符，默认 '*'
 * @returns 脱敏后的手机号
 */
export function formatPhone(
  phone: string | null | undefined,
  mask: string = '*',
): string {
  if (!phone) return EMPTY_PLACEHOLDER;
  const str = String(phone).trim();
  if (str.length < 7) return str;
  return `${str.slice(0, 3)}${mask.repeat(4)}${str.slice(-4)}`;
}

/**
 * 格式化文本 (截断 + 省略号)
 *
 * @param text - 原始文本
 * @param maxLength - 最大长度，默认 50
 * @param suffix - 省略后缀，默认 '...'
 * @returns 截断后的文本
 */
export function formatText(
  text: string | null | undefined,
  maxLength: number = 50,
  suffix: string = '...',
): string {
  if (!text) return EMPTY_PLACEHOLDER;
  if (text.length <= maxLength) return text;
  return `${text.slice(0, maxLength)}${suffix}`;
}
